/* WaveBeats — Song Form JS
 * File: assets/wavebeats-song-form.js
 */

var WBS_VARIANTS = {
  video_lyrique: 50995591348557,   // Vidéo Lyrique (+9€)
  streaming:     51941526012237,   // Streaming Spotify/Deezer/Apple (+19€)
  express:       50345935634765,   // Livraison Express (+39€)
};

/* ─── Accordion ─────────────────────────────────────────────────────────── */

function wbsToggle(header) {
  var body = header.nextElementSibling;
  var isClosed = header.classList.contains('wb-closed');
  if (isClosed) {
    header.classList.remove('wb-closed');
    body.classList.remove('wb-hidden');
  } else {
    header.classList.add('wb-closed');
    body.classList.add('wb-hidden');
  }
}

/* ─── Toggles ────────────────────────────────────────────────────────────── */

function wbsMention(checkbox) {
  var hidden = document.getElementById('wbs-mention-val');
  if (hidden) hidden.value = checkbox.checked ? 'Mentionner dans la chanson' : '';
}

/* ─── Companion products ─────────────────────────────────────────────────── */

var _wbsCart = {};

function wbsAddCompanion(key) {
  var variantId = WBS_VARIANTS[key];
  if (!variantId || _wbsCart[key]) return Promise.resolve();
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function(res) { if (res.ok) _wbsCart[key] = true; });
}

function wbsRemoveCompanion(key) {
  var variantId = WBS_VARIANTS[key];
  if (!variantId || !_wbsCart[key]) return Promise.resolve();
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  }).then(function(res) { if (res.ok) _wbsCart[key] = false; });
}

/* ─── Style "Autre" ──────────────────────────────────────────────────────── */

function wbsHandleStyleAutre(select) {
  var autreField = document.getElementById('wbs-f-style-autre');
  if (!autreField) return;
  if (select.value === 'Autre') {
    autreField.classList.remove('wb-hidden');
  } else {
    autreField.classList.add('wb-hidden');
    var input = document.getElementById('wbs-style-autre-input');
    if (input) input.value = '';
  }
}

/* ─── Option handlers ────────────────────────────────────────────────────── */

function wbsHandleVideo(select) {
  if (select.value === 'Oui') { wbsAddCompanion('video_lyrique'); }
  else { wbsRemoveCompanion('video_lyrique'); }
}

function wbsHandleStreaming(select) {
  if (select.value === 'Oui') { wbsAddCompanion('streaming'); }
  else { wbsRemoveCompanion('streaming'); }
}

function wbsHandleLivraison(select) {
  if (select.value === 'Express (24-48h)') { wbsAddCompanion('express'); }
  else { wbsRemoveCompanion('express'); }
}

/* ─── Form validation & submit ───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('wb-song-form');
  if (!form) return;

  // Brancher le handler livraison sur le select
  var livraisonSelect = form.querySelector('[name="properties[Livraison]"]');
  if (livraisonSelect) livraisonSelect.addEventListener('change', function() { wbsHandleLivraison(this); });

  form.addEventListener('submit', function(e) {
    var valid = true;
    var firstError = null;

    function require(fieldId, valueGetter) {
      var field = document.getElementById(fieldId);
      if (!field) return;
      var val = valueGetter ? valueGetter() : '';
      var empty = val === '' || val === null;
      if (empty) {
        field.classList.add('wb-invalid');
        valid = false;
        if (!firstError) firstError = field;
      } else {
        field.classList.remove('wb-invalid');
      }
    }

    // Étape 1
    require('wbs-f-destinataire', function() {
      return form.querySelector('[name="properties[Destinataire]"]').value.trim();
    });
    require('wbs-f-occasion', function() {
      return form.querySelector('[name="properties[Occasion]"]').value.trim();
    });
    require('wbs-f-histoire', function() {
      return form.querySelector('[name="properties[Demande particulière]"]').value.trim();
    });

    // Étape 2
    require('wbs-f-style', function() {
      return form.querySelector('[name="properties[Style]"]').value;
    });
    // Si "Autre" sélectionné, valider + injecter la valeur custom
    var styleSelect = form.querySelector('[name="properties[Style]"]');
    if (styleSelect && styleSelect.value === 'Autre') {
      var autreInput = document.getElementById('wbs-style-autre-input');
      var autreVal = autreInput ? autreInput.value.trim() : '';
      if (!autreVal) {
        var autreField = document.getElementById('wbs-f-style-autre');
        if (autreField) autreField.classList.add('wb-invalid');
        valid = false;
        if (!firstError) firstError = document.getElementById('wbs-f-style-autre');
      } else {
        // Injecter la valeur dans le select pour qu'elle parte avec la commande
        var opt = styleSelect.querySelector('option[value="Autre"]');
        if (opt) opt.value = autreVal;
        styleSelect.value = autreVal;
      }
    }
    require('wbs-f-voix', function() {
      return form.querySelector('[name="properties[Voix]"]').value;
    });

    // Étape 3
    require('wbs-f-video', function() {
      return form.querySelector('[name="properties[Vidéo Lyrique]"]').value;
    });
    require('wbs-f-streaming', function() {
      return form.querySelector('[name="properties[Streaming]"]').value;
    });
    require('wbs-f-livraison', function() {
      return form.querySelector('[name="properties[Livraison]"]').value;
    });

    if (!valid) {
      e.preventDefault();
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var stepBody = firstError.closest('.wb-step-body');
        if (stepBody && stepBody.classList.contains('wb-hidden')) {
          stepBody.classList.remove('wb-hidden');
          var stepHeader = stepBody.previousElementSibling;
          if (stepHeader) stepHeader.classList.remove('wb-closed');
        }
      }
    }
  });
});
